export const textColorVariants = {
  'text-color': {
    primary: 'text-text-primary',
    'primary-disabled': 'text-text-primary-disabled',
    'primary-hover': 'text-text-primary-hover',
    'primary-error': 'text-text-primary-error',
    'primary-error-hover': 'text-text-primary-error-hover',
    'primary-inverse': 'text-text-primary-inverse',
    'primary-core': 'text-text-primary-core',

    secondary: 'text-text-secondary',
    'secondary-disabled': 'text-text-secondary-disabled',
    'secondary-error': 'text-text-secondary-error',
    'secondary-error-hover': 'text-text-secondary-error-hover',

    legal: 'text-text-legal',
    'link-disabled': 'text-text-link-disabled',
    focused: 'text-text-focused',

    black: 'text-text-black',
    white: 'text-text-white',
    gray: 'text-text-gray',
    blue: 'text-mykonos',
    'grey-700': 'text-text-grey-700',
    purple: 'text-text-purple',
  },
  'text-color-sm': {
    primary: 'sm:text-text-primary',
    'primary-disabled': 'sm:text-text-primary-disabled',
    'primary-hover': 'sm:text-text-primary-hover',
    'primary-error': 'sm:text-text-primary-error',
    'primary-error-hover': 'sm:text-text-primary-error-hover',
    'primary-inverse': 'sm:text-text-primary-inverse',
    'primary-core': 'sm:text-text-primary-core',

    secondary: 'sm:text-text-secondary',
    'secondary-disabled': 'sm:text-text-secondary-disabled',
    'secondary-error': 'sm:text-text-secondary-error',
    'secondary-error-hover': 'sm:text-text-secondary-error-hover',

    legal: 'sm:text-text-legal',
    'link-disabled': 'sm:text-text-link-disabled',
    focused: 'sm:text-text-focused',

    black: 'sm:text-text-black',
    white: 'sm:text-text-white',
    gray: 'sm:text-text-gray',
    blue: 'sm:text-mykonos',
    'grey-700': 'sm:text-text-grey-700',
  },
  'text-color-md': {
    primary: 'md:text-text-primary',
    'primary-disabled': 'md:text-text-primary-disabled',
    'primary-hover': 'md:text-text-primary-hover',
    'primary-error': 'md:text-text-primary-error',
    'primary-error-hover': 'md:text-text-primary-error-hover',
    'primary-inverse': 'md:text-text-primary-inverse',
    'primary-core': 'md:text-text-primary-core',

    secondary: 'md:text-text-secondary',
    'secondary-disabled': 'md:text-text-secondary-disabled',
    'secondary-error': 'md:text-text-secondary-error',
    'secondary-error-hover': 'md:text-text-secondary-error-hover',

    legal: 'md:text-text-legal',
    'link-disabled': 'md:text-text-link-disabled',
    focused: 'md:text-text-focused',

    black: 'md:text-text-black',
    white: 'md:text-text-white',
    gray: 'md:text-text-gray',
    blue: 'md:text-mykonos',
    'grey-700': 'md:text-text-grey-700',
  },
  'text-color-lg': {
    primary: 'lg:text-text-primary',
    'primary-disabled': 'lg:text-text-primary-disabled',
    'primary-hover': 'lg:text-text-primary-hover',
    'primary-error': 'lg:text-text-primary-error',
    'primary-error-hover': 'lg:text-text-primary-error-hover',
    'primary-inverse': 'lg:text-text-primary-inverse',
    'primary-core': 'lg:text-text-primary-core',

    secondary: 'lg:text-text-secondary',
    'secondary-disabled': 'lg:text-text-secondary-disabled',
    'secondary-error': 'lg:text-text-secondary-error',
    'secondary-error-hover': 'lg:text-text-secondary-error-hover',

    legal: 'lg:text-text-legal',
    'link-disabled': 'lg:text-text-link-disabled',
    focused: 'lg:text-text-focused',

    black: 'lg:text-text-black',
    white: 'lg:text-text-white',
    gray: 'lg:text-text-gray',
    blue: 'lg:text-mykonos',
    'grey-700': 'lg:text-text-grey-700',
  },
  'text-color-xl': {
    primary: 'xl:text-text-primary',
    'primary-disabled': 'xl:text-text-primary-disabled',
    'primary-hover': 'xl:text-text-primary-hover',
    'primary-error': 'xl:text-text-primary-error',
    'primary-error-hover': 'xl:text-text-primary-error-hover',
    'primary-inverse': 'xl:text-text-primary-inverse',
    'primary-core': 'xl:text-text-primary-core',

    secondary: 'xl:text-text-secondary',
    'secondary-disabled': 'xl:text-text-secondary-disabled',
    'secondary-error': 'xl:text-text-secondary-error',
    'secondary-error-hover': 'xl:text-text-secondary-error-hover',

    legal: 'xl:text-text-legal',
    'link-disabled': 'xl:text-text-link-disabled',
    focused: 'xl:text-text-focused',

    black: 'xl:text-text-black',
    white: 'xl:text-text-white',
    gray: 'xl:text-text-gray',
    blue: 'xl:text-mykonos',
    'grey-700': 'xl:text-text-grey-700',
  },
}
